import { useEffect, useState } from "react";

import AlertComponent from "../../../helpers/alert/AlertComponent";
import { getAlertedProductsJourneyDocuments } from "../../../entities/alerted-product";

// Aplana el historial por categoría (pdf/excel) del servicio
// /api/alertas/jornada/documentos/?jornada_id=<id> en una sola lista de
// documentos adjuntos para la tabla del detalle de Centralización.
const flattenDocuments = (historyByCategory = { pdf: [], excel: [] }) => [
  ...historyByCategory.pdf.map((doc) => ({ ...doc, type: "PDF", isPdf: true })),
  ...historyByCategory.excel.map((doc) => ({ ...doc, type: "Excel", isPdf: false })),
];

export const useCentralizationDocuments = (journeyId) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!journeyId) {
      setDocuments([]);
      return undefined;
    }

    let cancelled = false;
    const fetchDocuments = async () => {
      setLoading(true);
      try {
        const result = await getAlertedProductsJourneyDocuments(journeyId);
        if (!cancelled) setDocuments(flattenDocuments(result.historyByCategory));
      } catch {
        if (cancelled) return;
        setDocuments([]);
        AlertComponent.error(
          "Error",
          "No fue posible cargar los documentos adjuntos"
        );
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchDocuments();
    return () => {
      cancelled = true;
    };
  }, [journeyId]);

  return { documents, loading };
};